module.exports = __webpack_public_path__ + "02_long_gold.2309eb4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_long_gold.png
// module id = A7/f
// module chunks = 0